import {
	type VoiceDictationResult,
	VoiceDictationState,
	type WebSpeechToTextAPIAction,
} from './WebSpeechToTextModels';

export const voiceDictationReducer = (
	result: VoiceDictationResult,
	action: WebSpeechToTextAPIAction,
): VoiceDictationResult => {
	switch (action.type) {
		case 'SET_INITIALIZING':
			return {
				state: VoiceDictationState.Initializing,
				transcription: null,
				ghostTranscription: null,
			};
		case 'SET_RECORDING':
			return {
				state: VoiceDictationState.Recording,
				transcription: action.payload.transcription,
				ghostTranscription: result.ghostTranscription ?? null,
				chunkIndex: action.payload.chunkIndex,
			};
		case 'SET_GHOST':
			// Allow ghost to work during Initializing (before STT LLM responds)
			// and during Recording (while STT LLM is sending text)
			if (
				result.state !== VoiceDictationState.Recording &&
				result.state !== VoiceDictationState.Initializing
			) {
				return result;
			}
			return {
				state: VoiceDictationState.Recording,
				transcription: result.state === VoiceDictationState.Recording ? result.transcription : '',
				ghostTranscription: action.payload.ghostTranscription,
				chunkIndex: result.state === VoiceDictationState.Recording ? result.chunkIndex : 0,
			};
		case 'SET_STOPPED':
			return {
				...result,
				state: VoiceDictationState.Stopped,
				stopReason: action.payload.stopReason,
				ghostTranscription: null,
			};
		case 'SET_ERROR':
			return {
				...result,
				state: VoiceDictationState.Error,
				error: action.payload.error,
			};
		default:
			return result;
	}
};
